import {postRequestSearch} from "./helper"
import {postRequestWithoutSession} from "./helper-without-session"
export const getAllSearchByFields = (data) => postRequestSearch('search-user',data);
export const resumeUpload = (data) => postRequestWithoutSession('upload-file',data);
export const getAllCityByCountry = (data) => postRequestWithoutSession('get-city',data);
export const getAllCountry = (data) => postRequestWithoutSession('country-list',data);
export const getAllCity = (data) => postRequestWithoutSession('get-all-city',data);





// WEBPACK FOOTER //
// ./src/api/FindRecCompany.js